import {
  DELETE_CA,
  FETCH_CERTIFICATION_AUTHORITIES,
  PATCH_CA,
  SHOW_UPLOAD,
} from './constants';

export function fetchCertificationAuthorities() {
  return {
    type: FETCH_CERTIFICATION_AUTHORITIES,
  };
}

export function deleteCA(id) {
  return {
    type: DELETE_CA,
    payload: id,
  };
}

export function patchCA({ id, name }) {
  return {
    type: PATCH_CA,
    payload: { id, name },
  };
}

export function showUpload(args) {
  return {
    type: SHOW_UPLOAD,
    payload: args,
  };
}
